export const userId = ({ featureFlags }) => featureFlags?.user_id
export const timestamp = ({ featureFlags }) => featureFlags?.timestamp
export const allFlags = ({ featureFlags }) => featureFlags?.flags || {}

export const getFeatureFlag = (state, flagName) =>
  allFlags(state)[flagName] ?? false

// Whether the flags are known: fetched (or restored from the cache), or the
// first fetch failed with nothing cached. Until then a flag reading `false`
// may just mean "not loaded yet" — see App.jsx#AppRoute, which waits on this
// before deciding a flag-gated route is off.
export const areSettled = ({ featureFlags }) =>
  !!featureFlags?.timestamp || !!featureFlags?.fetch_failed
